import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class TournamentsConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.tournaments, meta);
    }
    getTournamentDetails(q) {
        return this.applyQuery(QueryBuilder.getTournamentDetails(q));
    }
    getTournamentWinners(q) {
        return this.applyQuery(QueryBuilder.getTournamentWinners(q));
    }
    getTournaments(q) {
        return this.applyQuery(QueryBuilder.getTournaments(q));
    }
    getOptInTournaments(q) {
        return this.applyQuery(QueryBuilder.getOptInTournaments(q));
    }
    optIn(q) {
        return this.applyQuery(QueryBuilder.optIn(q));
    }
    getLeaderboards(q) {
        return this.applyQuery(QueryBuilder.getLeaderboards(q));
    }
}
//# sourceMappingURL=TournamentsConnection.js.map